import { HttpContext, HttpContextToken } from '@angular/common/http';

export const SKIP_GLOBAL_HTTP_ERROR = new HttpContextToken<boolean>(() => false);

export interface HttpRetryOptions {
  count: number;
  baseDelayMs: number;
  maxDelayMs: number;
}

export const ENABLE_HTTP_RETRY = new HttpContextToken<boolean>(() => false);
export const ALLOW_NON_IDEMPOTENT_RETRY = new HttpContextToken<boolean>(() => false);
export const HTTP_RETRY_OPTIONS = new HttpContextToken<HttpRetryOptions | null>(() => null);
export const REQUEST_ID = new HttpContextToken<string | null>(() => null);
export const REQUEST_ID_HEADER = 'x-request-id';

export function createRequestId(prefix = 'req'): string {
  const random = Math.random().toString(36).slice(2, 10);
  return `${prefix}-${Date.now().toString(36)}-${random}`;
}

export function withRequestId(requestId: string, context = new HttpContext()): HttpContext {
  return context.set(REQUEST_ID, requestId);
}

export function withHttpRetry(
  count = 3,
  baseDelayMs = 300,
  maxDelayMs = 2000
): HttpContext {
  return new HttpContext()
    .set(ENABLE_HTTP_RETRY, true)
    .set(HTTP_RETRY_OPTIONS, { count, baseDelayMs, maxDelayMs });
}

export function withNonIdempotentRetry(
  count = 3,
  baseDelayMs = 300,
  maxDelayMs = 2000
): HttpContext {
  return withHttpRetry(count, baseDelayMs, maxDelayMs)
    .set(ALLOW_NON_IDEMPOTENT_RETRY, true);
}
